import type { ItemStatus } from "@/lib/types";

/** Statuses shown under the Active tab on `/my-items`. */
export const MY_ITEMS_ACTIVE_TAB_STATUSES: readonly ItemStatus[] = [
  "approved",
  "new_submission",
  "pending_review",
  "resubmitted",
  "pending",
] as const;

/** Statuses shown under the Sold tab on `/my-items`. */
export const MY_ITEMS_SOLD_TAB_STATUSES: readonly ItemStatus[] = [
  "sold",
  "sold_elsewhere",
  "sale_complete",
  "payment_received",
  "item_collected",
  "payment_processed",
  "payment_in_process",
  "picked_up",
] as const;

/** Statuses shown under the History tab on `/my-items`. */
export const MY_ITEMS_HISTORY_TAB_STATUSES: readonly ItemStatus[] = [
  "archived",
  "rejected",
] as const;

/** In-review subset used by Active tab filters. */
export const MY_ITEMS_IN_REVIEW_STATUSES: readonly ItemStatus[] = [
  "new_submission",
  "pending_review",
  "pending",
  "resubmitted",
] as const;

/**
 * Sold-tab statuses that still imply seller follow-up on the sale pipeline.
 * Terminal / informational sold states are excluded (state-based attention).
 */
export const MY_ITEMS_ACTIONABLE_SOLD_ATTENTION_STATUSES: readonly ItemStatus[] =
  [
    "payment_received",
    "payment_in_process",
    "picked_up",
    "item_collected",
    "payment_processed",
  ] as const;
